import type { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import logoIcon from 'img/logos/logo.svg';

import ChangeAppLanguage from '../change_language';

import './authLayout.page.scss';

interface AuthLayoutProps {
    children: ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps): ReactElement => {
    const { t } = useTranslation('auth');

    return (
        <div>
            <div id="auth_layout">
                <div id="auth_layout_page" className="page">
                    <div className="main-content">
                        <div className="logo">
                            <img alt={t('login.clinical_logo_alt')} src={logoIcon} />
                        </div>
                        <div id="auth_layout_box">
                            <div className="auth-layout-box">
                                <div className="auth-layout-box-content" role="main">
                                    {children}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ChangeAppLanguage />
            </div>
        </div>
    );
};
